import React from "react";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import { QuestionsRoutes } from "../../../../../routes";

export default function CreateQuestionButton() {
    const { push } = useHistory();

    const onCreateQuestion = () => push(`${QuestionsRoutes.create}`);

    return (
        <Button variant={"outlined"} size={"small"} onClick={onCreateQuestion}>
            Создать новую задачу
        </Button>
    )
}